/**
 * Скрипт для автозаполнения формы регистрации из GET-параметров
 * Считывает параметры user и email из URL и заполняет соответствующие поля формы registerForm
 */


(function() {
    /**
     * Получает значение GET-параметра из URL
     * @param {string} name - название параметра
     * @returns {string|null} - значение параметра или null
     */
    function getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }
    
    /**
     * Триггерит события для поля формы (для активации валидации и анимации label)
     * @param {HTMLElement} field - поле формы
     */
    function triggerFieldEvents(field) {
        if (!field) return;
        
        // Создаем и отправляем события change и keyup для триггера валидации
        var changeEvent = new Event('change', { bubbles: true });
        var keyupEvent = new Event('keyup', { bubbles: true });
        
        field.dispatchEvent(changeEvent);
        field.dispatchEvent(keyupEvent);
        
        // Добавляем класс 'activate' к form__group для анимации label
        var formGroup = field.closest('.form__group');
        if (formGroup && field.value) {
            formGroup.classList.add('activate');
        }
    }
    
    /**
     * Открывает форму регистрации (если форма скрыта при ширине экрана меньше 1280px)
     */
    function openRegistrationForm() {
        var windowWidth = window.innerWidth || document.documentElement.clientWidth;
        
        if (windowWidth < 1280) {
            var formRegister = document.getElementById('form-register');
            
            if (formRegister && formRegister.classList.contains('hidden')) {
                formRegister.classList.remove('hidden');
            }

            var htmlElement = document.documentElement;
            if (!htmlElement.classList.contains('form-show')) {
                htmlElement.classList.add('form-show');
                
                // Показываем контейнер формы
                var formHeader = document.querySelector('.form-header');
                if (formHeader) {
                    formHeader.style.display = 'table';
                }
            }
        }
    }
    
    /**
     * Заполняет поля формы значениями из GET-параметров
     */
    function fillRegistrationForm() {
        // Получаем значения из GET-параметров
        var userName = getUrlParameter('user');
        var userEmail = getUrlParameter('email');

        var nameField = document.getElementById('name-regesterForm');
        var emailField = document.getElementById('email-regesterForm');

        if (userName && nameField) {
            nameField.value = userName;
            triggerFieldEvents(nameField);
        }

        if (userEmail && emailField) {
            emailField.value = userEmail;
            triggerFieldEvents(emailField);
        }

        if (userName && userEmail) {
            openRegistrationForm();
        }
    }
    
    // Выполняем заполнение после загрузки DOM
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fillRegistrationForm);
    } else {
        // DOM уже загружен
        fillRegistrationForm();
    }
    
    // Дополнительно выполняем заполнение при открытии формы (для случая с узким экраном)
    // Отслеживаем изменения видимости формы
    var formObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                var target = mutation.target;
                // Проверяем, стала ли форма видимой
                if (target.classList.contains('form-register') && !target.classList.contains('hidden')) {
                    fillRegistrationForm();
                }
            }
        });
    });
    
    // Запускаем наблюдение после загрузки DOM
    function startObserving() {
        var formContainer = document.querySelector('.form-register');
        if (formContainer) {
            formObserver.observe(formContainer, {
                attributes: true,
                attributeFilter: ['class']
            });
        }
    }
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', startObserving);
    } else {
        startObserving();
    }
})();
